import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

class DropDown extends React.PureComponent {
    constructor(props) {
        super(props);

        this.showOptions = this.showOptions.bind(this);
        this.hideOptions = this.hideOptions.bind(this);
        this.toggleOptions = this.toggleOptions.bind(this);
        this.updateValue = this.updateValue.bind(this);

        this.state = {
            showOptions: false,
            value: props.defaultValue,
        };
    }

    componentDidMount() {
        const {
            inputRef, validation,
        } = this.props;

        const { value } = this.state;

        // blur event on the input messes up the click even on the options.
        // using mousedown event helps but is not ideal.
        this.input.addEventListener('blur', this.hideOptions, false);

        this.input.addEventListener('change', validation, false);

        this.inputContainer.addEventListener('click', this.toggleOptions, false);

        this.input.setAttribute('readOnly', '');

        [...this.dropdown.children].forEach((o) => {
            o.addEventListener('mousedown', this.updateValue, false);
        });

        // bind the local ref to the ref passed through props
        if (inputRef) {
            inputRef(this.input);
        }

        // if there is no default value, set the first option as default
        const defaultOption = [...this.dropdown.children]
            .find((o) => o.dataset.value === value)
            ?? this.dropdown.children[0];

        // fire the mousedown event to validate the default.
        defaultOption.dispatchEvent(new Event('mousedown'));
    }

    componentDidUpdate() {
        const { value } = this.state;

        // We need this for when the options arrray is updated.
        // We need to make sure that any extra options are equiped

        const elements = [...this.dropdown.children];

        elements.forEach((o) => {
            o.removeEventListener('mousedown', this.updateValue, false);
            o.addEventListener('mousedown', this.updateValue, false);
        });

        let selectedExists = false;

        elements.forEach((o) => {
            if (o.dataset.value === `${value}`) {
                selectedExists = true;
            }
        });

        if (!selectedExists) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(() => ({
                value: elements[0]?.dataset?.value ?? '',
            }));
        }
    }

    updateValue(e) {
        // We want to dispatch an event so we have the input in scope

        this.setState(() => ({
            value: e.target.dataset.value,
            showOptions: false,
        }), () => this.input.dispatchEvent(new Event('change')));
    }

    toggleOptions() {
        const { showOptions } = this.state;
        if (showOptions === true) {
            this.hideOptions();
        } else {
            this.showOptions();
        }
    }

    showOptions() {
        const { showOptions } = this.state;
        if (showOptions === false) {
            this.setState(() => ({
                showOptions: true,
            }));
        }
    }

    hideOptions() {
        const { showOptions } = this.state;
        if (showOptions === true) {
            this.setState(() => ({
                showOptions: false,
            }));
        }
    }

    render() {
        const {
            name,
            placeholder,
            invalidclass,
            options,
            validation,
        } = this.props;
        const { showOptions, value } = this.state;

        const elements = options.map((o) => <div className={styles['custom-option']} data-value={o} key={`${name}${o}`}>{o}</div>);

        const arrow = showOptions ? styles.up : '';
        const show = showOptions ? styles.show : '';

        return (
            <div className={styles.dropdown}>
                <div className={`${styles.dropdownInput} ${arrow}`} ref={(ref) => { this.inputContainer = ref; }} data-testid={`${name}-dropdown`}>
                    <input
                        className={`input ${invalidclass}`}
                        ref={(ref) => { this.input = ref; }}
                        name={name}
                        placeholder={placeholder}
                        value={value}
                        onChange={validation}
                        data-testid={`${name}-input`}
                    />
                </div>
                <div className={`${styles['custom-dropdown']} ${show}`}>
                    <div ref={(ref) => { this.dropdown = ref; }}>
                        {elements}
                    </div>
                </div>
            </div>
        );
    }
}

DropDown.propTypes = {
    name: PropTypes.string.isRequired,
    inputRef: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    validation: PropTypes.func,
    placeholder: PropTypes.string.isRequired,
    invalidclass: PropTypes.string,
    defaultValue: PropTypes.string,
};

DropDown.defaultProps = {
    inputRef: () => { },
    validation: () => { },
    invalidclass: '',
    defaultValue: '',
};

export default DropDown;
